import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '',
  timeout: 20000
})

service.interceptors.response.use(
  (res) => res.data,
  (err) => Promise.reject(err)
)

export default service
